module.exports = __webpack_public_path__ + "static/media/Icone2-formation.efd71224.svg";